{
  "title": "Tiny Servant",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level transmutation",
  "level": 3,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S",
  "duration": "8 hours",
  "description": [
    "You touch one Tiny, nonmagical object that isn’t attached to another object or a surface and isn’t being carried by another creature. The target animates and sprouts little arms and legs, becoming a creature under your control until the spell ends or the creature drops to 0 hit points. See the stat block for its statistics.",
    "As a bonus action, you can mentally command the creature if it is within 120 feet of you. (If you control multiple creatures with this spell, you can command any or all of them at the same time, issuing the same command to each one.) You decide what action the creature will take and where it will move during its next turn, or you can issue a simple, general command, such as to fetch a key, stand watch, or stack some books. If you issue no commands, the servant does nothing other than defend itself against hostile creatures. Once given an order, the servant continues to follow that order until its task is complete.",
    "When the creature drops to 0 hit points, it reverts to its original form, and any remaining damage carries over to that form.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, you can animate two additional objects for each slot level above 3rd.",
    "Tiny Servant",
    "Tiny Construct",
    "Armor Class: 15 (natural armor)",
    "Hit Points: 10 (4d4)",
    "Speed: 30ft., climb 30 ft.",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "4 (-3)",
    "16 (+3)",
    "10 (+0)",
    "2 (-4)",
    "10 (+0)",
    "1 (-5)",
    "Damage Immunities poison, psychic",
    "Condition Immunities: blinded, charmed, deafened, exhaustion, frightened, paralyzed, petrified, poisoned",
    "Senses: blindsight 60 ft. (blind beyond this radius), passive Perception 10",
    "Languages: —",
    "Challenge: —",
    "Actions",
    "Slam. Melee Weapon Attack: +5 to hit, reach 5 ft., one target. Hit: 5 (1d4 + 3) bludgeoning damage."
  ],
  "spellLists": ["artificer", "wizard"]
}
